// Copyright © Veeam Software Group GmbH

export const EXPLORE_MAX_LIMIT = 2000;
